<script>
import {uploadFile} from "@/utils/oss";
import {formatImage} from "@/utils/format";

export default {
  name: 'UtUpload',
  props: {
    value: {
      type: String,
      required: true,
      default: ''
    },
    limit: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isUploading: {
      type: Boolean,
      default: false
    }

  },
  mounted() {

  },
  data(){
    return {
      dialogVisible: false,
    }
  },
  computed: {
    // 计算属性，返回当前显示的图片 URL
    currentImgUrl() {
      return this.value;
    }
  },
  methods: {
    formatImage,
    async handleUploadFile(file){
      // 单个上传到阿里云oss
      const res =  await uploadFile(file, 'device/type')
      console.log("上传成功",res)
      // 通过 input 事件更新 v-model 绑定的值
      this.$emit('input', res.key)
    },


  }
}

</script>

<template>
  <div>
    <el-upload
        :limit="limit"
        :accept="accept"
        :multiple="multiple"
        list-type="picture-card"
        :before-upload="handleUploadFile"
        :auto-upload="true"
        action="#"
    >
      <el-image v-if="currentImgUrl" :src="formatImage(currentImgUrl)" fit="fill" lazy/>
      <i v-else class="el-icon-plus" />
    </el-upload>

    <el-dialog v-model="dialogVisible">
      <img :src="formatImage(currentImgUrl)" alt="Preview Image" />
    </el-dialog>
  </div>
</template>

<style scoped>

</style>
